import React, {FunctionComponent} from "react";
import styles from "./loading.module.css";
import animations from "../../styles/animations.module.css";

interface LoadingIndicatorProps {
    disabled?: boolean;
}

export const LoadingIndicator : FunctionComponent<LoadingIndicatorProps> = (props) => {
    if (props.disabled)
        return (<></>);

    return (
        <div className={styles.loading_indicator}>
            <i className={animations.blink_delayed}/>
            <i className={animations.blink_delayed}/>
            <i className={animations.blink_delayed}/>
        </div>
    );
};